import { Controller } from "@hotwired/stimulus";

/*
 * Make labels and other elements fire click event when Enter or
 * Spacebar are pressed while focused.
 */
export default class extends Controller {
  keydown(event) {
    if (!this.isSpaceOrEnter(event.code, event.keyCode)) return;

    // Prevent scroll when spacebar is pressed.
    event.preventDefault();

    this.element.click();
  }

  isSpaceOrEnter(code, keyCode) {
    switch (code) {
      case "Enter":
      case "Space":
        return true;
      default:
        return false;
    }

    switch (keyCode) {
      case 13:
      case 32:
        return true;
      default:
        return false;
    }
  }
}
